export default __webpack_public_path__ + "static/media/bayelsa-terminal.4afc2e9a.png";